import { z } from "zod";
import { createRouter, query } from "react-safe-query";

const V3_API_BASE_URL = "https://api.v3.invintusmedia.com";
const WSC_API_KEY = "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU";

interface ClientCategoriesResponse {
  categoryID: string;
  categoryName: string;
  categoryDescription?: string | null;
  displayName: string;
  customData?: null;
  parentCategoryID?: string | null;
}

const getClientCategoriesPayloadSchema = z.object({
  clientID: z.string(),
});

export const categoryRouter = createRouter({
  getClientCategories: query(async (input: z.infer<typeof getClientCategoriesPayloadSchema>) => {
    const response = await fetch(`${V3_API_BASE_URL}/v2/Categories/getCategories`, {
      method: "POST",
      headers: {
        authorization: "console",
        "wsc-api-key": WSC_API_KEY,
      },
      body: JSON.stringify(input),
    });

    return (await response.json().then((json) => json.data)) as ClientCategoriesResponse[];
  }),
});
